export default __webpack_public_path__ + "static/media/materialui.2d853780.svg";